var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSellIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 13,
    viewBox: "0 0 10 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99994 0C3.64283 0 2.55354 1.12964 2.55354 2.53702V2.55549H0.75L0 11.2963V11.3148C0 12.2407 0.821493 13 1.83929 13H8.16072C9.17864 13 10 12.2407 10 11.3148L9.25 2.55545H7.44646V2.53698C7.44634 1.12959 6.35705 0 4.99994 0ZM3.14286 2.53702C3.14286 1.48139 3.98214 0.611148 4.99994 0.611148C6.01786 0.611148 6.85702 1.48153 6.85702 2.53702V2.55549L3.14286 2.53702ZM8.71429 3.16662L9.41071 11.3333C9.41071 11.926 8.83922 12.389 8.16075 12.389H1.83932C1.16071 12.389 0.58935 11.9075 0.58935 11.3333L1.28578 3.16662H2.5537V4.31475H3.14298L3.14286 3.16662H6.83929V4.31475H7.42857L7.42845 3.16662H8.71429Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.17678 5.82322C5.07915 5.72559 4.92085 5.72559 4.82322 5.82322L3.23223 7.41421C3.1346 7.51184 3.1346 7.67014 3.23223 7.76777C3.32986 7.8654 3.48816 7.8654 3.58579 7.76777L5 6.35355L6.41421 7.76777C6.51184 7.8654 6.67014 7.8654 6.76777 7.76777C6.8654 7.67014 6.8654 7.51184 6.76777 7.41421L5.17678 5.82322ZM5.25 11L5.25 6L4.75 6L4.75 11L5.25 11Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSellIcon);
export default __webpack_public_path__ + "static/media/sellIcon.5bc566f18a603e34fff001030c6b1214.svg";
export { ForwardRef as ReactComponent };